export const Today = () => (new Date()).toISOString().substring(0, 10);
export const printableTime = (hours: number, minutes: number, seconds?: number) => [
  `${hours < 10 ? '0' : ''}${hours}`,
  `${minutes < 10 ? '0' : ''}${minutes}`,
  seconds !== undefined && `${seconds < 10 ? '0' : ''}${seconds}`,
].filter(Boolean).join(':');
